import { MusicSubmissionsPageModel } from './model';
import { action } from 'mobx';
import { RedirectFunction, RouterState } from 'react-router';
import { PrismicController } from '../../prismic/controller';
import { BugsnagController } from '../../bugsnag/controller';
import { EnvModel } from '../../env/model';
import { UIController } from '../../ui/controller';

export class MusicSubmissionsPageController {

  constructor(
    private model: MusicSubmissionsPageModel,
    private prismic: PrismicController,
    private bugsnag: BugsnagController,
    private env: EnvModel,
    private ui: UIController
  ) {}

  @action
  onEnter = async (nextState: RouterState, replace: RedirectFunction) => {
    this.model.loading = true;
    const document = 'music_submissions';

    try {
      this.ui.setBreadcrumbs([{
        path: '/music-submissions',
        label: 'Music Submissions'
      }]);

      await this.ui.setSEO(nextState.location.pathname);

      const [{ data }] = await Promise.all([
        this.prismic.getSingle(document),
        this.env.ready
      ]);

      // RichText
      this.model.page_title = data.page_title;
      this.model.page_body = data.page_body;
      this.model.typeform_url = data.typeform_url;
      this.model.typeform_button_label = data.typeform_button_label;

      // Image
      this.model.cover_image = data.cover_image.url;

    } catch (e) {
      this.bugsnag.notifyException(e);
    } finally {
      this.model.loading = false;
    }

    return;
  };
}